import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/claude-code-social-media";

export const Route = createFileRoute(path)({
	component: ClaudeCodeSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using Claude Code",
			description:
				"Run social media from your terminal. AgentReacher's MCP server plugs into Claude Code so you can draft, schedule, and ship posts next to your repo.",
		}),
});

function ClaudeCodeSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="claude-code"
				title="Boost your Social Media using Claude Code"
				description="AgentReacher's MCP server plugs into Claude Code. Draft a launch post next to the diff that shipped it, queue a thread without leaving the CLI, and confirm before anything goes live."
				primaryCta={{ label: "Connect Claude Code", to: "/signup" }}
				secondaryCta={{ label: "Setup docs", to: "/docs/mcp" }}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
